import React, { useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import "./Integrations.css";
import styles from "./ProductCard.module.css";
import { integrations } from "./IntegrationData";
import { AuthorizationCard } from "../../../pages/AuthorizationCard";
import useLocalStorageState from "use-local-storage-state";
import { Button } from "react-bootstrap";
import nodata from "../../../Utils/assets/img/nodata.png";

export const Integrations = () => {
  const [customer] = useLocalStorageState("customer");
  const permission = customer.customer_details?.permission;
  const user_type = Number(customer.customer_details?.user_type);
  const [searchBarValue, setSearchBarValue] = useState("");
  // const { searchBarValue, isAdmin } = useOutletContext();
  const settingPermission = permission?.filter(
    (c) => c.module_name === "setting",
  );
  const integrationView =
    user_type !== 1
      ? Boolean(
          Number(
            settingPermission?.filter(
              (c) => c.feature_name === "integration",
            )[0]?.view,
          ),
        )
      : true;

  // console.log(searchBarValue, "saurabh");
  return (
    <div className="container mb-5">
      {/* <div className="d-flex flex-column text-start">
        <h2 className="h4 mb-2">Application Integrations</h2>
        <span className="text-muted mb-1" style={{ fontSize: "0.9rem" }}>
          You can manage Logo, Receipt, Admission, etc. information in the LMS
          system from here.
        </span>
        <hr
          className="mb-4"
          style={{
            borderTop: "0.5px solid #6c757d",
            opacity: "0.3",
            marginTop: "0.7rem",
          }}
        />
      </div> */}
      <div className="mb-3 d-flex justify-content-between align-items-end">
        {" "}
        <div style={{ lineHeight: "0.8rem" }}>
          <h6
            // className="addEnquiryHead"
            style={{ fontWeight: "500", color: "black", fontSize: "1.0rem" }}
          >
            Application Integrations
          </h6>
          <p className="text-muted mb-0 small" style={{ color: "#c7c7c7" }}>
            You can manage Logo, Receipt, Admission, etc. information in the LMS
            system from here.{" "}
          </p>
        </div>
        <div
          className="d-flex align-items-center gap-1"
          style={{ height: "39px" }}
        >
          {/* search bar */}
          <div className=" position-relative">
            <input
              type="text"
              style={{ fontSize: "12px", paddingLeft: "36px", height: "35px" }}
              className="form-control "
              value={searchBarValue}
              onChange={(e) => {
                setSearchBarValue(e.target.value);
              }}
            />
            <i
              class="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
          </div>
        </div>
      </div>

      <hr
        className="mt-2 mb-4"
        style={{
          borderTop: "0.5px solid #6c757d",
          opacity: "0.3",
        }}
      />

      {integrationView ? (
       
        <div
          className="row gx-3 gy-3 justify-content-start "
          style={{
           scrollbarColor:" #aaafb3 #f3f3f3",
           scrollbarWidth: "thin",
           height: "75vh",
           overflow: "scroll",
        }}
        >
          {(() => {
            const filteredData = integrations.filter((app) => {
              if (!searchBarValue) return true;
              const searchTerm = searchBarValue.toLowerCase();
              return (
                app.name.toLocaleLowerCase().includes(searchTerm) ||
                app.category.toLowerCase().includes(searchTerm)
              );
            });

            return filteredData.length === 0 ? (
              <div className="w-100 text-center mt-4">
                <img
                  src={nodata}
                  alt=""
                  style={{ width: "68vh", marginTop: "10%" }}
                />
              </div>
            ) : (
              filteredData.map((app, index) => (
                <div
                  className="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex"
                  key={index}
                >
                  <Link
                    to={app.path}
                    className="text-decoration-none text-dark w-100 d-flex flex-column"
                  >
                    <div
                      style={{ borderRadius: "8px" }}
                      className={`text-center border-0 shadow custom-card-integration ${styles.product_box} customBackground d-flex flex-column h-100`}
                    >
                      <div className="d-flex justify-content-center align-items-center">
                        <img
                          src={app.logo}
                          alt={app.name}
                          className={`img-fluid integrationImg ${styles.product_box_img}`}
                        />
                      </div>

                      <div
                        className={`${styles.description} d-flex flex-column flex-grow-1`}
                      >
                        <div
                          style={{ lineHeight: "0.9rem", marginBottom: "3px" }}
                        >
                          <h2
                            style={{
                              fontWeight: 600,
                              color: "#2e384e",
                              fontSize: "1.2rem",
                              textAlign: "start",
                              paddingTop: "6px",
                            }}
                          >
                            {app.name}
                          </h2>
                          <p className={styles.subhead2}>{app.category}</p>
                        </div>

                        <p
                          style={{
                            wordSpacing: "-0.5px",
                            color: "#968080",
                            fontSize: "0.9rem",
                            lineHeight: "1.5",
                            textAlign: "start",
                            fontWeight: "300",
                          }}
                          className="flex-grow-1"
                        >
                          {app.description}
                        </p>
                        <div className={styles.main}>
                          <Button
                            className="btnStyleIntegration"
                            style={{
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              borderRadius: "20px",
                            }}
                          >
                            INSTALL
                          </Button>
                          <p className={styles.main_p}>Free</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            );
          })()}
        </div>
      ) : (
        <AuthorizationCard />
      )}
    </div>
  );
};